import { Result } from 'journeys/portal/Forms/Sections.constants';

export const AsLeftTestTableSectionDataS81 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'AsLeftTestLabel',
                label: 'As Left Test',
                isLabel: true,
                xs: 12,
                fontWeight: 700,
                padding: '5px 0 0 8px'
            }]
        },
        {
            key: 2,
            fields: [{
                key: 'remark',
                label: `Remark: If a PASS then required to take a picture of the One Pager document and the Beamex latest Calibration Cert document.
                Submit is not allowed unless doc pictures are present.`,
                isLabel: true,
                xs: 12,
                fontWeight: '600',
                labelWidth: '100%',
                padding: '5px 1px 5px 8px',
                fontSize: '8.5pt',
                color: '#ea7c34',
            }]
        },
        {
            key: 3,
            fields: [{
                key: 'noData',
                isLabel: true,
                xs: 8
            },
            {
                key: 'F81AsLeftResultLabel',
                value: Result.AS_LEFT_RESULT_LABEL,
                width: '100%',
                readOnly: true,
                labelWidth: '0',
                height: '1.1rem',
                xs: 2,
                borderBottom: '0',
                borderRight: '0',
                borderTop: '0',
                borderLeft: '0',
                isLabelBold: true,
                textAlign: 'end',
                padding: '3px 5px 0px 0px',
                marginTop: '2px'
            },
            {
                key: 'F81AsLeftResult',
                value: formData?.F102AftResult === Result.RESULT_PASS ? '' : formData.F81AsLeftResult,
                isRequired: formData?.F102AftResult !== Result.RESULT_PASS,
                isDisabled: formData?.F102AftResult === Result.RESULT_PASS,
                readOnly: formData?.F102AftResult === Result.RESULT_PASS,
                isDropdown: formData?.F102AftResult !== Result.RESULT_PASS,
                placeholder: 'Select As-Left Result',
                options: [
                    { name: 'Select As-Left Result', value: '' },
                    { name: Result.RESULT_PASS, value: Result.RESULT_PASS },
                    { name: Result.RESULT_FAIL, value: Result.RESULT_FAIL }
                ],
                xs: 2,
                width: '98%',
                labelWidth: '0',
                inputMarginRight: formData?.F102AftResult === Result.RESULT_PASS ? '4px' : '0',
                height: formData?.F102AftResult === Result.RESULT_PASS ? '1.25rem' : '1.5rem',
                borderRight: '0',
                borderBottom: '0',
                marginBottom: '4px',
                textAlign: 'center',
            }]
        }
    ]
});
